export default {
    tempStorage: [
        ['基隆市環保局清潔隊', '連絡人：莊弘鉅 02-24669897分機 46', 'Email：i073218@mail.klcg.gov.tw'],
        ['臺北市政府環境保護局北區資源回收場、南區資源回收場', '連絡人：吳昆燐 27919622#108', 'Email：la-kunlin@gov.taipei'],
        ['新北市政府環境保護局(八里清潔隊、石門清潔隊)', '連絡人：方俐文', '電  話：(02)2953-2111#4045', 'Email：AP5260@ntpc.gov.tw'],
        ['桃園市環境清潔稽查大隊新屋區中隊', '電  話：(03)486-1197', '桃園市環境清潔稽查大隊大園區中隊', '電  話：(03)386-6360'],
        ['竹北市清潔隊', '連絡人： 謝承融', '電  話：03-5515919*373', 'Email：10007428@hchg.gov.tw'],
        ['新豐鄉清潔隊', '連絡人：曾嘉運', '電  話：03-5591116*247', 'Email：Willy3356@gmail.com'],
        ['新竹市環保局水土科', '連絡人： 林帝樺', '電  話：03-5368920-3009', 'Email：63698@ems.hccepb.gov.tw'],
        ['新竹市環境保護局水及土壤污染防治科', '連絡人：范先生 03-5368920 分機 3002'],
        ['苗栗縣後龍鎮清潔隊', '連絡人： 朱心嫻', '電 話：037 037 -731974 731974', 'Email ：Hins2016@ems.miaoli.gov.tw i'],
        ['苗栗縣苑裡鎮清潔隊', '連絡人： 嚴茂瑜', '電 話：037 037 -869699 869699', 'Email ：terryu06@yahoo.com.tw'],
        ['臺中市大安區清潔隊', '連絡人：蘇月姿隊員', '電  話：04-26712849', 'Email：s1112223@ms17.hinet.net'],
        ['臺中市清水區清潔隊(梧棲漁港)', '連絡人：陳冠宇 衛生稽查員', '電  話：04-2228-9111#66317', 'Email：yui@taichung.gov.tw'],
        ['彰化縣福興鄉清潔隊', '連絡人： 莊子賢', '電  話：(04) 7707030', 'Email：att363@mail.fusing.gov.tw'],
        ['彰化縣線西鄉清潔隊', '連絡人： 蔡美珠', '電  話：(04) 7580029', 'Email：alisatasi@yahoo.com.tw'],
        ['雲林縣四湖鄉公所清潔隊', '連絡人：李俞儒', '電  話：(05)7875755', 'Email：zuhu112@zuhu.gov.tw'],
        ['雲林縣環境保護局', '連絡人： 沈家儀', '電  話：05-5526262', 'Email：sula80028@gmail.com'],
        ['嘉義縣布袋鄉公所清潔隊', '連絡人：蘇紀達', '電  話：05-3477276', 'Email：gi.da@yahoo.com.tw'],
        ['嘉義縣東石鄉公所清潔隊', '連絡人：顏昌祺', '電  話：05-3709365', 'Email：s2340341@yahoo.com.tw'],
        ['臺南市南區清潔隊', '連絡人：黃建成', '電  話：06-2963004', 'Email：tsepa8899@gmail.com'],
        ['臺南市中西安平區清潔隊', '連絡人：陳建和', '電  話：06-3912221', 'Email：a0931881916@gmail.com'],
        ['高雄市旗津區清潔隊', '連絡人：侯遠德 隊長', '電  話：0976-783-241'],
        ['高雄市茄萣區清潔隊', '連絡人：郭俊男', '電  話：0929-403-075'],
        ['花蓮縣秀姑巒溪Cepo’水環境巡守隊', '連絡人： 何旺盛', '電  話：0977456625', 'Email：u19830625@nt.feng-bin.gov.tw'],
        ['花蓮市清潔隊', '連絡人： 邱盛龍', '電  話：03-823-3818', 'Email：Lun@nt.hualien.gov.tw'],
        ['臺東縣環境保護局水質保護科', '連絡人：朱小姐 089-221999 分機 30'],
        [
            '海洋及漁業發展所 南方澳漁港暫置區及烏石漁港暫置區',
            '連絡人：張傑荃 03-9252257 分機 225',
            '注意事項：海洋環境清理或淨灘後產生廢棄物，請於進場前14天申請，烏石漁港、南方澳漁港暫置區進場相關規定請先電話確認連絡，接受進場與否由管理單位決定。',
        ],
        [
            '長濱鄉清潔隊 長濱鄉公所貯存場清潔隊貯存場',
            '連絡人：張佑嘉(環保局) 089-221999 分機 404',
            'Email：t8206@epb.taitung.gov.tw',
            '海廢分類項目：漁網、廢紙容器、寶特瓶、鋁罐、塑膠容器、鐵罐、浮球',
        ],
        [
            '東河鄉清潔隊 東河鄉公所貯存場清潔隊貯存場',
            '連絡人：張佑嘉(環保局) 089-221999 分機 404',
            'Email：t8206@epb.taitung.gov.tw',
            '海廢分類項目：漁網、廢紙容器、寶特瓶、鋁罐、塑膠容器、鐵罐、浮球',
        ],
        ['屏東縣琉球鄉清潔隊', '連絡人：何忠信', '電 話：8612501轉169', 'Email：hcs59456@yahoo.com.tw'],
        ['屏東縣佳冬鄉塭豐漁港海洋廢棄物貯存專區', '連絡人：鄭榮賢', '電 話：0912-812376', 'Email：chengjung1028@gmail.com'],
        ['金門縣金沙鎮清潔隊', '連絡人：張舒媛', '電  話：082-354787', 'Email：kun769642@gmail.com'],
        ['金門縣烈嶼鄉陽山清潔隊', '連絡人：莊羅山', '電  話：082-364508', 'Email：same1192001@hotmail.com'],
        ['金門縣金湖鎮清潔隊', '連絡人： 蔡郁琪', '電  話：0928768682', 'Email：a0914059914@gmail.com'],
        ['金門縣金寧鄉清潔隊', '連絡人：楊宗寰', '電  話：(082)312493', 'Email：apple2000823@gmail.com'],
        ['金門縣金城鎮清潔隊', '連絡人：許燕騰', '電  話：0910976717', 'Email：kinmenlong@gmail.com'],
    ],
    coProduct: [
        ['新竹市環境保護局水及土壤污染防治科', '連絡人：范先生 03-5368920 分機 3002'],
        ['彰化縣環境保護局廢棄物管理科', '連絡人：李小姐 04-711-5655 分機 413'],
        ['嘉義縣環境保護局廢棄物管理科', '連絡人：林先生 05-3620800 分機 306'],
        ['屏東縣政府環境保護局環境衛生科', '連絡人：鄭小姐 08-7351911 分機 706'],
        ['臺東縣環境保護局水質保護科', '連絡人：朱小姐 089-221999 分機 303'],
    ],
}
